import React, { useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import DeviceVerificationRequired from './DeviceVerificationRequired';

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [deviceVerificationRequired, setDeviceVerificationRequired] = useState(false);
  const [verificationMessage, setVerificationMessage] = useState('');
  const [registrationAllowed, setRegistrationAllowed] = useState(false);

  useEffect(() => {
    checkRegistrationStatus();
  }, []);

  const checkRegistrationStatus = async () => {
    try {
      const response = await authAPI.checkRegistrationAllowed();
      setRegistrationAllowed(response.registration_allowed);
    } catch (err) {
      console.error('Error checking registration status:', err);
      // Default to false if there's an error
      setRegistrationAllowed(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(username, password);
      
      // Check if device verification is required
      if (response.device.requires_verification) {
        setDeviceVerificationRequired(true);
        setVerificationMessage(response.device.message);
      } else {
        // Device is verified, proceed with login
        if (onLoginSuccess) {
          onLoginSuccess(response.user);
        }
      }
    } catch (err) {
      setError(
        err.response?.data?.message || 
        err.response?.data?.errors?.username?.[0] ||
        'An error occurred during login'
      );
    } finally {
      setLoading(false);
    }
  };

  if (deviceVerificationRequired) {
    return (
      <DeviceVerificationRequired
        message={verificationMessage}
        username={username}
        password={password}
        onVerified={() => {
          setDeviceVerificationRequired(false);
          if (onLoginSuccess) {
            const user = JSON.parse(localStorage.getItem('user'));
            onLoginSuccess(user);
          }
        }}
      />
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        {registrationAllowed && (
          <div className="login-footer">
            <p>Don't have an account? <a href="/register">Register</a></p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
